import React from 'react';
import { get, isNull } from 'lodash';
import PropTypes from 'prop-types';
import { StyleSheet, View, Text } from '@react-pdf/renderer';
import { AllocationMatrix } from '../../../common/components/AllocationMatrix';
import getProjectMapping from '../../../../utils/ProjectUtils';

const styles = StyleSheet.create({
  projectHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 8,
    marginBottom: 4,
    paddingLeft: 3,
  },
});

export function EmployeeActivityDualAllocationMatrix({ data }) {
  const activityDualAllocation = get(data, 'userResponse.ActivityDualAllocation.data', {});
  const defaultActivityList = get(data, 'userResponse.Activity.data.defaultItems', []);
  const selectedActivityList = get(data, 'userResponse.Activity.data.selectedActivities', []);
  const totalActivitiesList = [...defaultActivityList, ...selectedActivityList];
  const activityMapping = {};

  // Create activity mapping
  totalActivitiesList.forEach(activity => {
    const activityId = get(activity, 'id', '');
    activityMapping[activityId] = get(activity, 'name', '');
  });

  // Create project mapping
  const { searchProjectsResponse } = data;
  const selectedProjects = get(data, 'userResponse.Project.data.selectedProjects', []);
  const projectMapping = getProjectMapping(selectedProjects, searchProjectsResponse);

  // Create employee mapping
  const employeeMapping = {};
  const employeeData = get(data, 'employeeData', []);
  if (!isNull(employeeData)) {
    employeeData.forEach(employee => {
      const employeeId = get(employee, 'recordId', '');
      employeeMapping[employeeId] = get(employee, 'employeeName', '');
    });
  }

  // Create separate matrices for each employee's projects
  return Object.entries(activityDualAllocation).map(([employeeId, projectData]) => {
    // For each project of this employee
    return Object.entries(projectData).map(([projectId, allocationData]) => {
      const projectName = projectMapping[projectId] || projectId.split('_').pop();

      return (
        <View key={`${employeeId}-${projectId}`}>
          <Text style={styles.projectHeader}>{projectName}</Text>
          <AllocationMatrix
            data={{ [employeeId]: allocationData }}
            projectActivityNameMapping={activityMapping}
            entityNameMapping={employeeMapping}
          />
        </View>
      );
    });
  });
}

EmployeeActivityDualAllocationMatrix.propTypes = {
  data: PropTypes.object.isRequired,
};

export default EmployeeActivityDualAllocationMatrix;
